import React from 'react';
import Reflux from 'reflux';
import { Map } from 'immutable';
import PureRenderMixin from 'react-pure-render/mixin';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import UserSessionStore from 'flux/stores/UserSessionStore';
import GlobalElementStore from 'shared/flux/stores/GlobalElementStore';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import GlobalElementConstants from 'shared/constants/GlobalElements';
import TeamViewStore from 'flux/stores/TeamViewStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import AddTagMenu from 'shared/components/tag/addTagMenu';
import { isGlobalElementManager } from 'main/components/show/cuesheet/cuesheetViewHelper';

export default React.createClass({
  displayName: 'TagRowMenu',

  mixins: [
    Reflux.connect(TeamViewStore, 'team'),
    Reflux.connect(GlobalElementStore, 'globalElement'),
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connectFilter(CuesheetStore, 'rowSelectionMode', (state) =>
      state.get('rowSelectionMode'),
    ),
    PureRenderMixin,
  ],

  propTypes: {
    item: React.PropTypes.any.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    const { tags, activeTags } = this.props;
    // popoverVisibility, team, user, rowSelectionMode, globalElement
    const { rowSelectionMode, globalElement } = this.state;

    if (rowSelectionMode || !isGlobalElementManager()) return null;

    return (
      <AddTagMenu
        teamId={globalElement.get('teamId')}
        eventId={globalElement.get('eventId')}
        popoverTitle="Add tags to element"
        displayNode={this._getDisplayNode()}
        tags={tags}
        activeTagIds={activeTags.map((tag) => tag.get('_id'))}
        wrapperClasses="row-menu-tag"
        placement="bottom"
        popoverId={this._getPopoverId()}
        onChange={this._handleTagsChange}
      />
    );
  },

  _handleTagsChange(tagIds) {
    const { tags, rowIndex } = this.props;

    const unassignedTag = tags.find((tag) => {
      return GlobalElementConstants.labels.unassigned.text === tag.get('text');
    });

    /**
     * When there are more than one tag on the row, the unassigned should be removed
     */
    if (tagIds.size > 1) {
      const unassignedTagIndex = tagIds.indexOf(unassignedTag.get('_id'));
      tagIds =
        unassignedTagIndex !== -1
          ? tagIds.splice(unassignedTagIndex, 1)
          : tagIds;
    } else if (tagIds.size === 0) {
      /**
       * When all tags are all removed, assign the unassigned tag to the row
       */
      tagIds = tagIds.push(unassignedTag.get('_id'));
    }

    CuesheetRowActions.updateRow(rowIndex, Map({ labels: tagIds }));
  },

  _getPopoverId() {
    const { item } = this.props;
    return `${item.get('_id')}_tagMenu`;
  },

  _getDisplayNode() {
    return (
      <div>
        <Icon name="tag" className="pointer" />
      </div>
    );
  },
});
